// Generated automatically by nearley, version 2.20.1
// http://github.com/Hardmath123/nearley
(function () {
function id(x) { return x[0]; }
 function EXTRACT(x) { return x[0]; } 
 function ALT_EXTRACT(x) { return x[0][0]; } 
 function kv(key, value) { return {key, value}; } 
 function array_literal(entries = [], rest) {
	const type = "array_literal"
	if (rest) {
		return {
			type,
			entries: [
				...entries,
				kv("...rest", rest),
			],
		};
	}
	return {
		type,
		entries,
	};
} 
 function list_literal(entries = [], rest) {
	const type = "list_literal"
    const pairedEntries = entries.map((e, i) => kv(i, e))
	if (rest) {
		return {
			type,
			entries: [
				...pairedEntries,
				kv("...rest", rest),
			],
		};
	}
	return {
		type,
		entries: pairedEntries,
	};
} 
 function record_type(type, keyType, valueType) { return {type, keyType, valueType}; } 
 function flatten_csv(first, rest, extraction) {
	return [first, ...rest.map(extraction)];
} var grammar = {
    Lexer: undefined,
    ParserRules: [
    {"name": "main$ebnf$1", "symbols": []},
    {"name": "main$ebnf$1", "symbols": ["main$ebnf$1", "main_body"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "main", "symbols": ["main$ebnf$1"], "postprocess": x => EXTRACT(x).filter(x => x)},
    {"name": "main_body$subexpression$1", "symbols": ["array_literal"]},
    {"name": "main_body$subexpression$1", "symbols": ["array_record"]},
    {"name": "main_body$subexpression$1", "symbols": ["list_literal"]},
    {"name": "main_body$subexpression$1", "symbols": ["list_record"]},
    {"name": "main_body$subexpression$1", "symbols": ["text"]},
    {"name": "main_body", "symbols": ["main_body$subexpression$1"], "postprocess": ALT_EXTRACT},
    {"name": "array_literal$string$1", "symbols": [{"literal":"a"}, {"literal":"r"}, {"literal":"r"}, {"literal":"a"}, {"literal":"y"}, {"literal":"{"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "array_literal", "symbols": ["array_literal$string$1", "_", {"literal":"}"}], "postprocess": x => array_literal()},
    {"name": "array_literal$string$2", "symbols": [{"literal":"a"}, {"literal":"r"}, {"literal":"r"}, {"literal":"a"}, {"literal":"y"}, {"literal":"{"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "array_literal", "symbols": ["array_literal$string$2", "_", "keyval_body", "_", {"literal":"}"}], "postprocess": x => array_literal(x[2])},
    {"name": "array_literal$string$3", "symbols": [{"literal":"a"}, {"literal":"r"}, {"literal":"r"}, {"literal":"a"}, {"literal":"y"}, {"literal":"{"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "array_literal$string$4", "symbols": [{"literal":"."}, {"literal":"."}, {"literal":"."}, {"literal":"<"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "array_literal", "symbols": ["array_literal$string$3", "_", "keyval_body", "_", {"literal":","}, "_", "array_literal$string$4", "type", {"literal":","}, "__", "type", {"literal":">"}, "_", {"literal":"}"}], "postprocess": x => array_literal(x[2], record_type("array", x[7], x[10]))},
    {"name": "list_literal$string$1", "symbols": [{"literal":"l"}, {"literal":"i"}, {"literal":"s"}, {"literal":"t"}, {"literal":"{"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "list_literal", "symbols": ["list_literal$string$1", "_", {"literal":"}"}], "postprocess": x => list_literal()},
    {"name": "list_literal$string$2", "symbols": [{"literal":"l"}, {"literal":"i"}, {"literal":"s"}, {"literal":"t"}, {"literal":"{"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "list_literal", "symbols": ["list_literal$string$2", "_", "list_body", "_", {"literal":"}"}], "postprocess": x => list_literal(x[2])},
    {"name": "list_literal$string$3", "symbols": [{"literal":"l"}, {"literal":"i"}, {"literal":"s"}, {"literal":"t"}, {"literal":"{"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "list_literal$string$4", "symbols": [{"literal":"."}, {"literal":"."}, {"literal":"."}, {"literal":"<"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "list_literal", "symbols": ["list_literal$string$3", "_", "list_body", "_", {"literal":","}, "_", "list_literal$string$4", "type", {"literal":">"}, "_", {"literal":"}"}], "postprocess": x => list_literal(x[2], x[7])},
    {"name": "keyval_body$ebnf$1", "symbols": []},
    {"name": "keyval_body$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "_", "literal_body"]},
    {"name": "keyval_body$ebnf$1", "symbols": ["keyval_body$ebnf$1", "keyval_body$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "keyval_body", "symbols": ["literal_body", "keyval_body$ebnf$1"], "postprocess": ([first, repeat]) => flatten_csv(first, repeat, (x) => x[2])},
    {"name": "literal_body$ebnf$1", "symbols": [{"literal":"?"}], "postprocess": id},
    {"name": "literal_body$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "literal_body", "symbols": ["key", "literal_body$ebnf$1", {"literal":":"}, "_", "type"], "postprocess": x => kv(x[0], x[4])},
    {"name": "list_body$ebnf$1", "symbols": []},
    {"name": "list_body$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "_", "type"]},
    {"name": "list_body$ebnf$1", "symbols": ["list_body$ebnf$1", "list_body$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "list_body", "symbols": ["type", "list_body$ebnf$1"], "postprocess": ([first, repeat]) => flatten_csv(first, repeat, (x) => x[2])},
    {"name": "array_record$string$1", "symbols": [{"literal":"a"}, {"literal":"r"}, {"literal":"r"}, {"literal":"a"}, {"literal":"y"}, {"literal":"<"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "array_record", "symbols": ["array_record$string$1", "type", {"literal":","}, "__", "type", {"literal":">"}], "postprocess": x => record_type("array", x[1], x[4])},
    {"name": "array_record$string$2", "symbols": [{"literal":"a"}, {"literal":"r"}, {"literal":"r"}, {"literal":"a"}, {"literal":"y"}, {"literal":"<"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "array_record", "symbols": ["array_record$string$2", "type", {"literal":">"}], "postprocess": x => record_type("array", "array-key", x[1])},
    {"name": "list_record$string$1", "symbols": [{"literal":"l"}, {"literal":"i"}, {"literal":"s"}, {"literal":"t"}, {"literal":"<"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "list_record", "symbols": ["list_record$string$1", "type", {"literal":">"}], "postprocess": x => record_type("list", "int", x[1])},
    {"name": "key$subexpression$1", "symbols": ["keyword"]},
    {"name": "key$subexpression$1", "symbols": ["sqstring"]},
    {"name": "key", "symbols": ["key$subexpression$1"], "postprocess": ALT_EXTRACT},
    {"name": "type$subexpression$1", "symbols": ["keyword"]},
    {"name": "type$subexpression$1", "symbols": ["array_literal"]},
    {"name": "type$subexpression$1", "symbols": ["array_record"]},
    {"name": "type$subexpression$1", "symbols": ["list_literal"]},
    {"name": "type$subexpression$1", "symbols": ["list_record"]},
    {"name": "type", "symbols": ["type$subexpression$1"], "postprocess": ALT_EXTRACT},
    {"name": "type$string$1", "symbols": [{"literal":"a"}, {"literal":"r"}, {"literal":"r"}, {"literal":"a"}, {"literal":"y"}, {"literal":"-"}, {"literal":"k"}, {"literal":"e"}, {"literal":"y"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "type", "symbols": ["type$string$1"], "postprocess": EXTRACT},
    {"name": "type", "symbols": ["sqstring"], "postprocess": x => `'${x}'`},
    {"name": "keyword$ebnf$1", "symbols": [/[a-zA-Z_0-9]/]},
    {"name": "keyword$ebnf$1", "symbols": ["keyword$ebnf$1", /[a-zA-Z_0-9]/], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "keyword", "symbols": ["keyword$ebnf$1"], "postprocess": x => x[0].join("")},
    {"name": "text", "symbols": [/[^{<]/], "postprocess": x => null},
    {"name": "_$ebnf$1", "symbols": []},
    {"name": "_$ebnf$1", "symbols": ["_$ebnf$1", /[ \t]/], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "_", "symbols": ["_$ebnf$1"], "postprocess": x => null},
    {"name": "__$ebnf$1", "symbols": [/[ \t]/]},
    {"name": "__$ebnf$1", "symbols": ["__$ebnf$1", /[ \t]/], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "__", "symbols": ["__$ebnf$1"], "postprocess": x => null},
    {"name": "sqstring$ebnf$1", "symbols": []},
    {"name": "sqstring$ebnf$1", "symbols": ["sqstring$ebnf$1", "sqchar"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "sqstring", "symbols": [{"literal":"'"}, "sqstring$ebnf$1", {"literal":"'"}], "postprocess": x => x[1].join("")},
    {"name": "sqchar", "symbols": [/[^']/], "postprocess": EXTRACT},
    {"name": "sqchar$string$1", "symbols": [{"literal":"\\"}, {"literal":"'"}], "postprocess": function joiner(d) {return d.join('');}},
    {"name": "sqchar", "symbols": ["sqchar$string$1"], "postprocess": x => "'"}
]
  , ParserStart: "main"
}
if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
   module.exports = grammar;
} else {
   window.grammar = grammar;
}
})();
